// Transaction Inquiry

<template>
  <section class="lms3300-container">
    <div class="lms3300 white border-main shadow-dark">
      <Ul class="crumbs text-charcoal mb-2" v-show="!isLoggedOn">
        <li><sym-link to="/">Home</sym-link></li>
        <li><span aria-current="page">Transaction Inquiry</span></li>
      </Ul>

      <div class="page-title lams curved my-2">
        <h5 class="serif mb-0">
          <i class="fa fa-question-circle fa-lg ml-1 mr-2"></i>Transaction
          Inquiry
        </h5>
      </div>

      <div class="favorites" v-show="isLoggedOn">
        <button
          type="button"
          class="primary-light border-main w-100 text-center shadow-soft mb-1"
          @click="openFavorites = !openFavorites"
          @mousedown="onButtonMouseDown"
          v-show="hasFavorites"
        >
          <i class="fa fa-heart-o fa-lg mr-2"></i>Favorites
        </button>

        <sym-collapse v-model="openFavorites">
          <table>
            <thead>
              <tr class="whitesmoke">
                <th class="w-40">Region</th>
                <!-- <th class="w-30">Transaction</th> -->
                <th class="w-30">Transaction No.</th>
                <th class="w-30" colspan="2"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(fav, index) in favorites" :key="index">
                <td class="w-40">{{ fav.regionFullName }}</td>
                <td class="w-30">{{ fav.transactionId }}</td>
                <td class="w-15 px-1 py-0">
                  <button
                    type="button"
                    class="lams-light border-main w-100 sm-1 text-center"
                    title="Open"
                    @click="onOpenFavorite(fav)"
                    @mousedown="onButtonMouseDown"
                  >
                    <i class="fa fa-folder-open-o fa-lg"></i>
                  </button>
                </td>
                <td class="w-15 px-1 py-0">
                  <button
                    type="button"
                    class="primary-light border-main w-100 sm-1 text-center"
                    title="Delete favorite"
                    @click="onRemoveFavorite(fav)"
                    @mousedown="onButtonMouseDown"
                  >
                    <i class="fa fa-times fa-lg"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </sym-collapse>
      </div>

      <div
        class="controls lams-light curved-bottom mb-3 shadow-light border-main mt-3"
      >
        <sym-combo
          plain
          vertical
          align="bottom"
          v-model="regionId"
          caption="Region"
          display-field="regionFullName"
          :datasource="regions"
          @changing="onRegionIdChanging"
        ></sym-combo>

        <div class="trx-search">
          <sym-text
            plain
            vertical
            align="bottom"
            v-model="transactionId"
            caption="Transaction Number"
            @changed="onSearch"
          ></sym-text>
          <!-- <sym-text plain vertical align="bottom" v-show="isOfficerAdmin" v-model="lotNumber" caption="Lot Number" @changed="onSearch"></sym-text>
        <sym-text plain vertical align="bottom" v-show="isOfficerAdmin" caption="Client Name" @changed="onSearch"></sym-text>
         -->
          <button
            type="button"
            class="search-btn warning border-main shadow"
            @click="onSearch"
          >
            <i class="fa fa-search fa-lg"></i>
            <p class="mb-0"><span class="lg-2">Search</span></p>
          </button>
        </div>
      </div>

      <sym-alert class="floralwhite border-main" dismissible v-show="!isLoaded">
        <p class="mb-0">
          Transaction Number is the tracking number issued to you by LAMS
          Philippines (via SMS) when you applied or submitted any of the
          following:
        </p>
        <hr class="separator" />
        <ul class="actions mb-2">
          <li>Public Land Application (PLA)</li>
          <li>Inspection , Verification and Approval of Survey (IVAS)</li>
          <!-- <li>Inquiry / Requests</li> -->
        </ul>
      </sym-alert>

      <div class="trx-info shadow-light" v-if="trxInfo" ref="trx-info">
        <div
          class="trx-info-header justify-between align-items-center p-1 px-2 lams border-main curved-top mb-0 border-bottom-0"
        >
          <span class="bold lg-1"
            ><i class="fa fa-chevron-right mr-1"></i> Transaction Info</span
          >
          <button
            type="button"
            class="add-fav-btn warning-light mb-0 sm-1"
            @click="onAddFavorite"
            v-show="isLoggedOn"
          >
            <i class="fa fa-plus-circle fa-lg mr-2"></i>Add to Favorites
          </button>
        </div>

        <table>
          <tbody class="white text-charcoal">
            <tr>
              <!-- <td class="info-label whitesmoke">Transaction</td> -->
              <td class="info-label whitesmoke">Transaction No.</td>
              <td class="info-value">{{ trxInfo.transactionId }}</td>
            </tr>
            <tr>
              <td class="info-label whitesmoke">Status</td>
              <td class="info-value lg-1 bold">
                {{ trxInfo.trxStatusDescription }}
              </td>
            </tr>
            <tr v-if="trxInfo.trxStatusId === 'P'">
              <td class="info-label whitesmoke">Remarks</td>
              <td class="info-value lg-1 primary-light">
                {{ trxInfo.remarks }}
              </td>
            </tr>
            <tr>
              <td class="info-label whitesmoke">Lot</td>
              <td class="info-value">{{ trxInfo.requestedLot }}</td>
            </tr>
            <tr>
              <td class="info-label whitesmoke">Location</td>
              <td class="info-value">{{ trxInfo.requestedLocation }}</td>
            </tr>
            <tr>
              <td class="info-label whitesmoke">Survey Plan</td>
              <td class="info-value">{{ trxInfo.surveyPlan }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="trx-details shadow-light" v-show="trxInfo">
        <p
          class="p-2 bold lams-light border-main curved-top mb-0 border-bottom-0"
        >
          <i class="fa fa-chevron-right mr-1"></i> Details
        </p>

        <table class="table-scroll">
          <thead class="ivory">
            <tr class="text-charcoal">
              <th class="w-15">Date / Time</th>
              <th class="w-20">Workgroup</th>
              <th class="w-20" v-show="isOfficerAdmin">Assigned To</th>
              <th class="w-10">Status</th>
              <th class="w-20">Task</th>
              <th class="w-15">Remarks</th>
            </tr>
          </thead>

          <tbody class="white text-charcoal">
            <tr v-for="(routing, index) in routings" :key="index">
              <td>
                {{
                  core.toDateFormat(
                    routing.createDate,
                    true,
                    "dd MMM yyyy h:mmtt"
                  )
                }}
              </td>
              <td>{{ routing.workgroupDescription }}</td>
              <!-- <td>{{ routing.userName }}</td> -->
              <td v-show="isOfficerAdmin">{{ routing.userName }}</td>
              <td>{{ routing.trxStatusDescription }}</td>
              <td>{{ routing.action }}</td>
              <td>{{ routing.remarks }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <button
        type="button"
        class="primary text-center w-100 lg-1 shadow mt-2 mb-2"
        @click="goBack()"
      >
        <i class="fa fa-arrow-left mr-2"></i> Back
      </button>
    </div>
  </section>
</template>

<script>
import { get, ajax } from "../../js/http";

import { appConfig } from "../../js/session";

import * as lams from "../../js/lams";

import PageBase from "../PageBase.vue";

export default {
  extends: PageBase,
  name: "lms3300",

  data() {
    return {
      regions: [],
      regionId: 0,
      transactionId: "",
      // lotNumber: '',
      // clientName: '',

      trxInfo: null,
      routings: [],

      accountCode: "",
      favorites: [],
      openFavorites: false,
      isLoaded: false,
    };
  },

  computed: {
    isLoggedOn() {
      return (
        this.sym.userInfo.accountTypeId === 1 ||
        this.sym.userInfo.accountTypeId === 2
      );
    },

    hasFavorites() {
      return this.favorites.length;
    },

    isOfficerAdmin() {
      // console.log(this.sym.userInfo.accountTypeId === 1 || this.sym.userInfo.accountTypeId === 2);
      return (
        this.sym.userInfo.accountTypeId === 1 ||
        this.sym.userInfo.accountTypeId === 2
      );
    },
  },

  methods: {
    getTargetPath() {
      const me = this,
        q = {};

      if (me.regionId) {
        q.regionId = me.regionId;
      }

      if (me.transactionId) {
        q.transactionId = me.transactionId;
      }

      // if (me.lotNumber) {
      //   q.lotNumber = me.lotNumber;
      // }

      // if (me.clientName) {
      //   q.clientName = me.clientName;
      // }

      return {
        name: me.$options.name,
        query: q,
      };
    },

    syncValues(p, q) {
      const me = this;

      if ("regionId" in q) {
        if (me.core.isInteger(q.regionId)) {
          me.regionId = parseInt(q.regionId);
        }
      } else {
        me.regionId = 0;
      }

      if ("transactionId" in q) {
        if (me.core.isInteger(q.transactionId)) {
          me.transactionId = q.transactionId;
        }
      } else {
        me.transactionId = "";
      }

      // if ('lotNumber' in q) {
      //   if (me.core.isInteger(q.lotNumber)) {
      //     me.lotNumber = q.lotNumber;
      //   }
      // } else {
      //   me.lotNumber = '';
      // }

      // if ('clientName' in q) {
      //   if (me.core.isInteger(q.clientName)) {
      //     me.clientName = q.clientName;
      //   }
      // } else {
      //   me.clientName = '';
      // }
    },

    loadData() {
      const me = this,
        wait = me.wait();

      me.getTransactionInfo()
        .then((info) => {
          if (info && info.length) {
            me.trxInfo = info[0];
            me.isLoaded = true;
            return me.getRoutings();
          } else {
            me.trxInfo = null;
            return Promise.resolve([]);
          }
        })
        .then((routings) => {
          me.stopWait(wait);
          if (routings) {
            me.routings = routings;
          }
          me.openFavorites = false;
        })
        .catch((fault) => {
          me.stopWait(wait);
          me.showFault(fault);
        });
    },

    // API calls

    getLinkStatus(regionId) {
      const options = this.getApiOptions();

      return ajax("api/regions/" + regionId + "/link-status", options);
    },

    getTransactionInfo() {
      const trxId = this.transactionId ? parseInt(this.transactionId) : 0;
      if (!trxId) {
        return Promise.resolve([]);
      }

      const options = this.getApiOptions();
      // console.log('api/rgn/' + this.regionId + '/transactions/' + trxId + '/info', options);
      return ajax(
        "api/rgn/" + this.regionId + "/transactions/" + trxId + "/info",
        options
      );
    },

    getRoutings() {
      const trxId = this.transactionId ? parseInt(this.transactionId) : 0;
      if (!trxId) {
        return Promise.resolve([]);
      }
      const options = this.getApiOptions();

      return ajax(
        "api/rgn/" + this.regionId + "/transactions/" + trxId + "/routings",
        options
      );
    },

    getFavorites() {
      return get("api/accounts/" + this.accountCode + "/regions-transaction");
    },

    createFavorite() {
      const options = {
        method: "POST",
      };

      let q =
        "regionId=" + this.regionId + "&transactionId=" + this.transactionId;

      return ajax(
        "api/accounts/" + this.accountCode + "/region-transaction?" + q,
        options
      );
    },

    removeFavorite(fav) {
      const options = {
        method: "DELETE",
      };

      let q =
        "regionId=" + fav.regionId + "&transactionId=" + fav.transactionId;

      return ajax(
        "api/accounts/" + this.accountCode + "/region-transaction?" + q,
        options
      );
    },

    getApiOptions() {
      return {
        headers: {
          Token: appConfig.apiToken,
          Accept: "application/json",
        },
      };
    },

    // event handlers

    onRegionIdChanging(e) {
      const me = this;

      let regionInfo = me.regions.find(
        (obj) => obj.regionId === e.proposedValue
      );
      e.message = `Region '${regionInfo.regionFullName}' is offline.`;

      if (!regionInfo.apiHostAddress && regionInfo.regionId) {
        e.preventDefault();
        return;
      }

      if (e.proposedValue) {
        e.callback = me.regionIdCallback;
      }
    },

    regionIdCallback(e) {
      const me = this,
        wait = me.wait();

      return me.getLinkStatus(e.proposedValue).then(
        (statusCode) => {
          me.stopWait(wait);

          let isOnline = statusCode === 200;
          return isOnline;
        },
        () => {
          me.stopWait(wait);
          return false;
        }
      );
    },

    onSearch() {
      const me = this;

      if (!me.regionId) {
        me.advice.fault("Region is required.");
        me.setFocus("regionId");
        return;
      }

      if (!me.transactionId) {
        me.advice.fault("Transaction Number is required.");
        me.setFocus("transactionId");
        return;
      }

      me.trxInfo = null;
      // me.reload();
      me.loadData();
    },

    onOpenFavorite(fav) {
      const me = this;

      me.getLinkStatus(fav.regionId).then(
        (statusCode) => {
          if (statusCode !== 200) {
            me.advice.fault(`Region '${fav.regionFullName}' is offline.`);
            return;
          }
          me.openFavorites = false;
          me.regionId = fav.regionId;
          me.transactionId = fav.transactionId.toString();
          // me.reload();
          me.loadData();
        },
        () => {}
      );
    },

    onAddFavorite() {
      const me = this;

      me.createFavorite()
        .then(() => {
          return me.getFavorites();
        })
        .then((list) => {
          me.favorites = list;
        })
        .catch((fault) => {
          me.showFault(fault);
        });
    },

    onRemoveFavorite(fav) {
      const me = this,
        index = me.favorites.findIndex(
          (obj) =>
            obj.regionId === fav.regionId &&
            obj.transactionId === fav.transactionId
        );

      me.removeFavorite(fav).then(
        () => {
          if (index > -1) {
            me.favorites.splice(index, 1);
          }
          me.openFavorites = me.favorites.length > 0;
        },
        (fault) => {
          me.showFault(fault);
        }
      );
    },

    onButtonMouseDown(e) {
      e.preventDefault();
    },
  },

  mounted() {
    const me = this;

    me.accountCode = me.sym.userInfo.accountCode;
    me.regions = lams.getRegionList().filter((o) => o.apiHostAddress);
    me.regions.unshift({
      regionId: 0,
      regionFullName: "--- Select Region ---",
    });

    if (me.isLoggedOn) {
      me.getFavorites()
        .then((list) => {
          me.favorites = list;
        })
        .catch((fault) => {
          me.showFault(fault);
        });
    }

    me.syncValues(me.params, me.query);
    me.loadData();
  },

  beforeRouteUpdate(to, from, next) {
    this.syncValues(to.params, to.query);
    next();

    this.loadData();
    // if (Object.keys(from.query).length) {
    //  this.loadData();
    // }
  },
};
</script>

<style scoped>
.lms3300-container {
  display: flex;
  justify-content: center;
  padding-top: 1.5rem;
  padding-bottom: 3rem;
}

.lms3300 {
  width: 80%;
  padding: 1rem 2rem;
  border-radius: 0.375rem;
}

.page-title {
  padding: 0.875rem;
}

.favorites tr {
  line-height: 1;
}

.controls {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 0.5rem;
  column-gap: 1.5rem;
  padding: 1rem 2rem;
  padding-bottom: 1.5rem;
}

.controls >>> .form-control,
.controls >>> button {
  margin-bottom: 2px;
}

.controls >>> .input-tag {
  padding-bottom: 2px;
  margin-left: 2px;
}

.trx-search {
  display: grid;
  grid-template-columns: 2fr 1fr;
  column-gap: 1rem;
}

.search-btn {
  max-height: 2.3125rem;
  align-self: flex-end;
}

.separator {
  margin-bottom: 0.5rem;
}

.actions li {
  margin-left: 1.25rem;
}

.alert.fade-enter-active {
  transition: opacity 1s;
}

.alert.fade-leave-active {
  transition: opacity 0.5s;
}

.trx-info-header {
  display: flex;
}

.trx-info tr {
  line-height: 1;
}

.trx-details {
  margin-bottom: 1rem;
}

.table-scroll {
  overflow-x: auto;
  white-space: nowrap;
  display: block;
}

.trx-info td {
  vertical-align: top;
}

.trx-details td {
  vertical-align: top;
}

.info-label {
  width: 18%;
}

.info-value {
  width: 82%;
}

@media (max-width: 1100px) {
  .trx-search {
    grid-template-columns: 3fr 2fr;
  }
}

@media (max-width: 1024px) {
  .lms3300 {
    width: 90%;
    padding: 2rem;
  }
}

@media (max-width: 900px) {
  .controls {
    padding: 1rem;
    column-gap: 1rem;
  }
}

@media (max-width: 760px) {
  .lms3300-container {
    padding-top: 0;
    padding-bottom: 0;
  }
  .lms3300 {
    width: 98%;
    padding: 1rem;
    border-radius: 0;
  }
  .info-label {
    width: 25%;
  }
  .info-value {
    width: 75%;
  }
}

@media (max-width: 700px) {
  .controls {
    grid-template-columns: 2fr 3fr;
  }
}

@media (max-width: 620px) {
  .controls {
    grid-template-columns: 1fr;
    gap: 0.25rem;
  }
  .trx-search {
    grid-template-columns: 5fr 2fr;
  }
  .info-label {
    width: 35%;
  }
  .info-value {
    width: 65%;
  }
}

@media (max-width: 480px) {
  .trx-search {
    grid-template-columns: 3fr 2fr;
    column-gap: 0.5rem;
  }
}

@media (max-width: 420px) {
  .lms3300 {
    padding: 0.5rem;
  }
}

@media (max-width: 340px) {
  .controls {
    padding: 0.5rem;
  }
}

@media (max-width: 320px) {
  .trx-info-header {
    display: block;
  }
  .add-fav-btn {
    margin-top: 0.25rem;
  }
}
</style>
